import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import TenantPage from 'layouts/TenantPage';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Option } from 'shared/types/general';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import { movementReasonService } from '../api/movement-reason.service';
import { movementService } from '../api/movement.service';
import { UninvoicedMovementsColumns } from '../uninvoiced-movements';

export const UninvoicedMovements = () => {
  const translationPrefix = 'pages.movements.uninvoiced';
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [movementReasons, setMovementReasons] = useState<Option[]>([]);

  useEffect(() => {
    dispatch(loadingActions.startLoading());
    movementReasonService.getAllPaginated().then((res) => {
      setMovementReasons(res.results);
    });
    dispatch(loadingActions.stopLoading());
  }, []);

  const columns: GridColDef[] = UninvoicedMovementsColumns(
    movementReasons.map((reason) => reason.code)
  );

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <EnhancedDataGrid
        columns={columns}
        service={movementService}
        outerParams={{ ddt_closed: 'false', billable: 'true', invoice: 'false' }}
      />
    </TenantPage>
  );
};

export default UninvoicedMovements;
